import { Component, ViewChild, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { SignatureComponent } from '../../../../../signature/signature.component';
import { PAGES } from '../../dynamic-details.constants';
import _get from 'lodash-es/get';

@Component({
  selector: 'cm-signature-content',
  templateUrl: './signature-content.component.html',
  styleUrls: ['./signature-content.component.scss'],
})
export class DynamicSignatureComponent implements AfterViewInit {
  @ViewChild(SignatureComponent) signatureComponent: SignatureComponent;
  @Input() step;
  @Output() signatureSubmit: EventEmitter<string> = new EventEmitter();
  @Output() screenChange: EventEmitter<string> = new EventEmitter();
  error;

  ngAfterViewInit() {
    const signatureEl = _get(this.signatureComponent, 'signatureContainer.nativeElement');
    if (signatureEl) {
      signatureEl.scrollIntoView();
    }
  }

  backToPreviousPage() {
    this.screenChange.emit(PAGES.BACK);
  }

  submit() {
    this.error = this.signatureComponent.getSignatureErrors();

    if (!this.error) {
      this.signatureSubmit.emit(this.signatureComponent.signature);
    }
  }
}
